import React, { useEffect, useState } from "react";
import classNames from "classnames/bind";
import { EditIcon, DeleteIcon } from "../../../../components/Icons/Icons";
import { Pagination, Table as TB, Toast, Alert } from "../../../../components";
import useFetchData from "../../../../hooks/useFetchData";
import { Link, useNavigate } from "react-router-dom";
import { role } from "../../../../services/api/RoleApi";
import { formatDDMMYY, sorterArray } from "../../../../utils";
import styles from "./Table.module.css";
import NameCol from "../../../../components/NameCol";

const cx = classNames.bind(styles);
const Table = ({ onGetStatus, nameRole }) => {
  const [isRefresh, setIsRefresh] = useState(false);
  const [code, setCode] = useState();
  const [isShow, setIsShow] = useState(false);
  const [currentPage, setCurrentPage] = useState(1)
  const [toggleSort, setToggleSort] = useState(false)
  const [dataTable, setDataTable] = useState()
  const [method, setMethod] = useState('')
  let errorMess = "xem quyền người dùng";
  const { data, pages, status } = useFetchData("/userType/get-list-userType/", {
    company_code: sessionStorage.getItem("company_code"),
    page: currentPage,
    size: 10,
    isRefresh: isRefresh,
    user_type_name: nameRole,
  }, errorMess);
  const navigate = useNavigate()
  const handleShowAlert = (id) => {
    setCode(id);
    setIsShow(true);
  };

  useEffect(() => {
    setCurrentPage(1)
  }, [nameRole])
  const handleDelete = () => {
    async function deleteRole() {
      try {
        const res = await role.deleteRole(code);
        if (res.result) {
          setIsRefresh(!isRefresh);
          setIsShow(false);
          Toast.open("Xóa quyền thành công", "success");
        }
      } catch (e) {
        if (e.response.status === 403) {
          Toast.open("Bạn không có quyền xóa quyền người", "danger");
        } else {
          Toast.open("Xóa quyền không thành công", "danger");
        }
        setIsShow(false);
      }
    }
    deleteRole();
  };
  const handleClose = () => {
    setIsShow(false);
  };


  useEffect(() => {
    const newData = data && data?.data?.length > 0 ? data : null
    if (newData && method.length > 0) {
      switch (toggleSort) {
        case 'up':
          const dataSortUp = sorterArray(newData.data, method)
          setDataTable(dataSortUp)
          break;
        case 'down':
          const dataSortDown = sorterArray(newData.data, method)
          setDataTable(dataSortDown.reverse())
          break;
        default:
          setDataTable(newData.data)
          break;
      }
    } else {
      setDataTable(newData?.data)
    }
  }, [data, toggleSort, method])

  const handleSort = (type, method) => {
    if (type !== toggleSort) {
      setToggleSort(type)
      setMethod(method)
    } else {
      setToggleSort(false)
      setMethod('')
    }
  }

  const handleVideInfo = (code) => {
    navigate(`/admin/role/edit/${code}`)
  }
  const dataSource = dataTable?.map((item, index) => {
    return {
      stt: (<div onClick={() => handleVideInfo(item.CODE)} className={cx('center')}>{index + 1}</div>),
      name: (<div onClick={() => handleVideInfo(item.CODE)}>{item.SUBJECT_NAME}</div>),
      description: (<div onClick={() => handleVideInfo(item.CODE)}>{item.NOTE}</div>),
      user_add: (<div onClick={() => handleVideInfo(item.CODE)}>{item.EDIT_USER}</div>),
      date: (<div onClick={() => handleVideInfo(item.CODE)}>{formatDDMMYY(item.EDIT_TIME)}</div>),
      action: (
        <div className={cx("actions")}>
          <div className={cx("btn", "confirm")} onClick={() => handleVideInfo(item.CODE)}>
            <EditIcon />
          </div>
          <div
            onClick={(e) => handleShowAlert(item.CODE)}
            className={cx("btn", "cancel")}
          >
            <DeleteIcon />
          </div>
        </div>
      ),
    };
  });

  const columns = [
    {
      label: "STT",
      key: "stt",
    },
    {
      label: <NameCol active={method} title={'Tên quyền'} handleSort={handleSort} method={'SUBJECT_NAME'} />,
      key: "name",
    },
    {
      label: <NameCol active={method} title={"Mô tả"} handleSort={handleSort} method={'NOTE'} />,
      key: "description",
    },
    {
      label: <NameCol active={method} title={"Người gán"} handleSort={handleSort} method={'EDIT_USER'} />,
      key: "user_add",
    },
    {
      label: <NameCol active={method} title={"Lần sửa đổi gần nhất"} handleSort={handleSort} method={'EDIT_TIME'} />,
      key: "date"
    },
    {
      label: "Hành động",
      key: "action",
    },
  ];


  const handleNext = () => {
    setCurrentPage(currentPage + 1);
  };

  const handlePrevious = () => {
    setCurrentPage(currentPage - 1);
  };

  const handleClick = (page) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    if (status !== 200) {
      onGetStatus(status)
    }
  }, [status])
  return (
    <div>
      {isShow && (
        <Alert
          onOk={handleDelete}
          title="Khi xóa quyền này sẽ xóa toàn bộ tài khoản có quyền này!"
          onClose={handleClose}
        />
      )}
      <TB data={dataSource} colum={columns} />
      {data?.data?.length > 0 && (
        <div className={cx("pagination")}>
          <Pagination pages={pages} currentPage={currentPage} onNext={handleNext} onPrevious={handlePrevious} onClick={handleClick} />
        </div>
      )}
      <div id="__notification"></div>
    </div>
  );
};

export default Table;
